import { alertEscalate, alertUpdateStatus } from "api/alerts";
import GenericDialog from "./generic";
import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "store/appSlice";
import AlertsActionsForm, {
  AlertsActionsFormType,
} from "widgets/forms/alerts/actions";

const AlertsActionsDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  context: "ESCALATE" | "ACKNOWLEDGED" | "CLOSED" | "COMMENT";
  alertId: string;
}) => {
  const { isOpen, onClose, onSuccess, context, alertId } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleEscalate = async (formData: AlertsActionsFormType) => {
    dispatch(setLoading(true));
    const { status } = await alertEscalate(alertId, formData.comment);
    if (status === 200) {
      onSuccess();
      notifySimple(t("notification.alert.escalate.success"), "success");
    } else {
      notifySimple(t("notification.alert.escalate.error"), "error");
    }
    dispatch(setLoading(false));
  };

  const handleUpdateStatus = async (formData: AlertsActionsFormType) => {
    dispatch(setLoading(true));
    const { status } = await alertUpdateStatus(
      alertId,
      formData.comment,
      context as "CLOSED" | "ACKNOWLEDGED" | "COMMENT"
    );
    if (status === 200) {
      onSuccess();
      notifySimple(t("notification.alert.update-status.success"), "success");
    } else {
      notifySimple(t("notification.alert.update-status.error"), "error");
    }
    dispatch(setLoading(false));
  };

  return (
    <GenericDialog
      isOpen={isOpen}
      onExit={onClose}
      title={t("dialog.alerts.actions.title", {
        context: context.toLowerCase(),
      })}
    >
      <div className="-mt-4 mb-4 text-txt-sm text-secondary">
        {t("dialog.alerts.actions.description", {
          context: context.toLowerCase(),
        })}
      </div>
      <AlertsActionsForm
        submit={(data) => {
          if (context === "ESCALATE") {
            handleEscalate(data);
          } else {
            handleUpdateStatus(data);
          }
        }}
        onClose={onClose}
      />
    </GenericDialog>
  );
};

export default AlertsActionsDialog;
